<template>
  <v-app class="grey lighten-3" v-if="isLoggedIn">
    <v-layout>
      <div class="btn">
        <v-snackbar
          v-model="snackbar"
          :right="x === 'right'"
          :timeout="timeout"
          color="red"
          :top="y === 'top'"
        >
          {{ errorMsg }}
          <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
      </div>
      <v-flex xs12 sm8 offset-sm1>
        <v-container grid-list-md>
          <v-layout>
            <v-flex xs12 sm12 md12>
              <v-toolbar class="project mt-2">
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                  <v-btn flat class="white--text" @click="editProjectPage()">
                    Edit project
                  </v-btn>
                  <v-btn
                    flat
                    class="white--text"
                    v-if="getProjectType() == 2"
                    @click="locationPage()"
                  >
                    Edit Location
                  </v-btn>
                  <v-btn flat class="white--text" @click="back()">
                    Question
                  </v-btn>
                  <!-- <v-btn flat v-if="getProjectType() == 1" @click="budgetPage()">Edit Budget</v-btn>
                  <v-btn flat v-if="getProjectType() == 2" @click="locationBasedBudgetPage()">Edit Location Budget</v-btn> -->
                </v-toolbar-items>
              </v-toolbar>
            </v-flex>
          </v-layout>
          <v-card>
            <v-card-title class="project">
              <div class="white--text headline">
                <span class="headline">
                  Edit Assign Project to Team or General Dashers
                </span>
              </div>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap v-if="indexData.teams">
                  <v-flex xs12 sm12 md12>
                    <div>
                      <v-btn
                        color="red"
                        class="white--text"
                        v-if="projectTeamData.dasher_category == 1"
                      >
                        <v-icon>done</v-icon>
                        General Dasher
                      </v-btn>
                      <v-btn
                        color="red"
                        class="white--text"
                        v-else
                        @click="select_category(1)"
                      >
                        General Dasher
                      </v-btn>

                      <v-tooltip bottom v-if="indexData.teams.length < 1">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="red"
                            class="white--text"
                            v-if="indexData.teams.length < 1"
                            v-on="on"
                          >
                            <v-icon>close</v-icon>
                            Team Dasher
                          </v-btn>
                        </template>
                        <span>
                          You have team to assign. Please create team fast.
                        </span>
                      </v-tooltip>
                      <v-btn
                        color="red"
                        class="white--text"
                        v-if="
                          indexData.teams.length > 0 &&
                          projectTeamData.dasher_category != 2
                        "
                        @click="select_category(2)"
                      >
                        Team Dasher
                      </v-btn>
                      <v-btn
                        color="red"
                        class="white--text"
                        v-if="projectTeamData.dasher_category == 2"
                      >
                        <v-icon>done</v-icon>
                        Team Dasher
                      </v-btn>
                    </div>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                    v-if="projectTeamData.dasher_category == 2"
                  >
                    <v-select
                      v-model="projectTeamData.team"
                      :rules="team"
                      :items="indexData.teams"
                      :item-text="textItem"
                      item-value="id"
                      multiple
                      box
                      @change="calculateDasherNumber"
                      label="Select Team"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                flat
                color="success"
                v-if="projectTeamData.dasher_category == 2"
              >
                Number Available Dasher(
                {{ projectTeamData.numberOfDasherAvailable }})
              </v-btn>
              <button class="button" flat @click="back">Back</button>
              <v-btn class="button" flat @click="submit">Save & next</v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";
  import router from "@/router";

  export default {
    data: () => ({
      apiUrl: "project-dasher-category",
      snackbar: false,
      y: "top",
      x: "right",
      timeout: 4000,
      projectTeamData: {
        team: [],
        numberOfDasherAvailable: 0,
        noTeam: false,
        dasher_category: 1,
        project_id: null,
      },
      defaultItem: {
        team: [],
        numberOfDasherAvailable: 0,
        noTeam: false,
        dasher_category: 1,
        // project_id: null,
      },
      submitTeamData: {
        data: [],
      },

      valid: true,
      team: [(v) => v.length > 0 || "Teams is required"],
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      dasher_category_check: function () {
        // console.log(this.dasher_category);
        return true;
      },

      binding() {
        const binding = {};

        if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

        return binding;
      },
    },

    watch: {},

    created() {
      this.initialize();
      // this.editedData()
    },
    methods: {
      initialize() {
        var project_id_modify = JSON.parse(
          localStorage.getItem("project_id_modify")
        );
        this.projectTeamData.project_id = project_id_modify;
        this.$store.dispatch("indexData", [this.apiUrl, project_id_modify]);

        // console.log(this.projectTeamData);
      },
      select_category(value) {
        this.projectTeamData.dasher_category = value;
      },

      getProjectType() {
        if (this.indexData.project_data) {
          if (this.indexData.project_data.project_type_id) {
            return this.indexData.project_data.project_type_id;
          }
        }
        return false;
      },

      textItem: function (event) {
        return (
          event.team_name +
          " : " +
          event.team_code +
          "(" +
          event.numberOfDasher +
          ")"
        );
      },
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },
      calculateDasherNumber: function () {
        var numberOfDasherAvailable = 0;
        if (this.projectTeamData.team.length) {
          this.projectTeamData.team.forEach((elements) => {
            this.indexData.teams.forEach((element) => {
              if (elements == element.id) {
                numberOfDasherAvailable =
                  parseInt(numberOfDasherAvailable) +
                  parseInt(element.numberOfDasher);
              }
            });
          });
          this.projectTeamData.numberOfDasherAvailable =
            numberOfDasherAvailable;
        } else {
          this.projectTeamData.numberOfDasherAvailable = 0;
        }
        // console.log(this.projectTeamData.numberOfDasherAvailable);
      },

      back() {
        localStorage.setItem(
          "EditTeamDasherObject",
          JSON.stringify(this.projectTeamData)
        );
        var project_id = JSON.parse(localStorage.getItem("project_id"));
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-question",
        ]);
      },
      editProjectPage() {
        router.push("/edit-project");
      },
      editQuestion() {
        var project_id = JSON.parse(localStorage.getItem("project_id"));
        this.$store.dispatch("indexDataAndRout", [
          "project-dasher-category",
          project_id,
          "/edit-assign-teams-to-Project",
        ]);
      },
      locationPage() {
        var project_id = JSON.parse(localStorage.getItem("project_id"));
        this.$store.dispatch("indexDataAndRout", [
          "response-location",
          project_id,
          "/edit-address",
        ]);
      },
      locationBasedBudgetPage() {
        var project_id = JSON.parse(localStorage.getItem("project_id"));
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-budget2",
        ]);
        // router.push("/budget2");
      },
      budgetPage() {
        var project_id = JSON.parse(localStorage.getItem("project_id"));
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          project_id,
          "/edit-budget",
        ]);
        // router.push("/budget");
      },

      submit() {
        // console.log(this.projectTeamData);

        if (this.$refs.form.validate()) {
          if (
            this.projectTeamData.dasher_category == 2 &&
            this.projectTeamData.team.length == 0
          ) {
            alert("please select at lest a team");
          } else {
            this.submitTeamData.data = this.projectTeamData;
            this.$store.dispatch("storeOrUpdateTeamAssignmentModify", [
              "assign-teams-to-project-modify",
              this.submitTeamData,
            ]);
          }
          this.snackbar = true;
          this.close();
        }
      },
    },
  };
</script>

<style scoped>
  .icon {
    background: #ff2e2e;
    color: aliceblue;
    cursor: pointer;
    border-radius: none;
    margin: 10px;
  }
  .delete {
    color: #3f51b5;
    cursor: pointer;
  }
  span {
    width: 30px;
    cursor: pointer;
  }
  .button {
    font-size: 16px;
    background: #ff2e2e;
    padding: 0.4rem 1.3rem;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 10px;
    color: white;
  }
  .headline {
    color: white;
  }
  .project {
    background: #ff2e2e;
  }
</style>
